import React, { useEffect, useState, useContext } from 'react'
import './single.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
// import Chart from '../../../components/chart/Chart'
import { doc, getDoc, onSnapshot, collection, query, where, getDocs, updateDoc } from "firebase/firestore"
import {  Link, useParams } from "react-router-dom"
import { db } from '../../../firebase'
import Switch from '@mui/material/Switch';
import img from '../../../assets/images/user.png'
import ConfirmStatusBox from '../../../components/ConfirmStatusBox'
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
// import UserOrderTable from '../../../components/table/Use
import ConfirmBox from '../../../components/ConfirmBox';
import commentorPhoto from '../../../assets/images/user.png'

import outlet from '../../../assets/images/outlet-2.png'

import { AuthContext } from '../../../context/AuthContext'


const Single = ({user}) => {

  const {advertId} = useParams()

  const [ advertData, setAdvertData ] = useState("")

  const [ userData, setUserData ] = useState([])

  const [ review, setReview] = useState([])

  const [accountUser, setAccountUser] = useState(false) 

  const [checked, setChecked] = React.useState(true);

  const [photos, setPhotos] = useState([])
 
  const [ openModal, setOpenModal ] = useState(false)

  const [payment, setPayment] = useState([])

  const closeModal = () => setOpenModal(false)

  const [openStatus, setOpenStatus] = useState(false)


  const { currentUser } = useContext(AuthContext)
        
  const userIds = currentUser.uid;
      
  const [adminRole, setAdminRole] = useState("")


      
  const getAdminRole = async() => {
    
    const docRef = doc(db, "admins", userIds);

    const docSnap = await getDoc(docRef);

    
    if (docSnap.exists()) {

      setAdminRole(docSnap.data().role)

    } else {

      console.log("No such document!");
    }
  }


  useEffect(()=>  {

    getAdminRole()

  }, [])
    
  



  const handleChange = (event) => {

    setChecked(event.target.checked);

  };




  useEffect(() => {

    const docRef = doc(db, "adverts", advertId);

    const unsubscribe = onSnapshot(docRef, (docSnap) => {

      if (docSnap.exists()) {

        setAdvertData({ id: docSnap.id, ...docSnap.data() });

      } else {
        
        setAdvertData(null);

      }

    }, (error) => {

      console.error("Error listening to document:", error);

    });

    return () => unsubscribe();

  }, [advertId]);


  

  // const getAdverts = async() => {

  //     const docRef = doc(db, "adverts", advertId);

  //     const docSnap = await getDoc(docRef);

    
      
  //     if (docSnap.exists()) {

  //       setAdvertData(docSnap.data())

  //       setAccountUser(true)

  //       setPhotos(docSnap.data().advertImage)
  //       // console.log(advertData)
  //     } else {
  //       // doc.data() will be undefined in this case
  //       console.log("No such document!");
  //     }
  // }

  // useEffect(()=>{

  //   getAdverts()

  // }, [])


   useEffect(() => {
    
    //LISTEN REAL TIME

    const reviewQuery = async() => {

      const reviewRef = (collection(db, "reviews"));
      const q = query(reviewRef, where("subId", "==", advertId));

      const querySnapshot = await getDocs(q);
        let list = []
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        list.push(doc.data())
        // console.log(doc.id, " => ", doc.data());
        console.log(list)

        setReview(list)
        // console.log(orderData)
      });

    }
    
    reviewQuery()   

  },[])





const handleModal = (photo) => {

  setOpenModal(true) 
  setPhotos(photo)

}


  const options = {  maximumFractionDigits: 2 }


  const Modal = ({open, close, photo}) => {
     
    if(!open) return null
    return(
     <div style={{
      backgroundColor: 'black',
      widows:'100%',
      height:'100%',
     }}>
       <div style={{

        maxWidth: 600,
        backgroundColor: 'white',
      }}>
       
         <div className="modalRight">
           <p className="closeBtn" onClick={close}>X</p>
           <div></div>

 
         </div>
       </div>
     </div>
    )
}


     const handleStatus = async() => {
    
        
        const advertRef = doc(db, "adverts", advertId);
    
        await updateDoc(advertRef, {
    
        status: advertData.status === "active" ? 'inactive' : 'active', 
    
     })
    
      setOpenStatus(false)
    
      }
 

  return (
    <div className='single'>

      <Modal open={openModal} close={closeModal} />

      <Sidebar/>
      <div className='singleContainer'>
        <Navbar/>
          <div className='topContainer'>
            <div className='topLeft'><h1>Single Advert</h1></div>
            
            <div className='topRight'>
            <Breadcrumbs aria-label="breadcrumb">
              <a underline="hover" color="inherit" href="/">
                Home
              </a>
              <a
                underline="hover"
                color="inherit"
                href="/adverts"
              >
                Advert List
              </a>
              <Typography color="green">Single Advert</Typography>
            </Breadcrumbs>
            </div>
          </div>
        <div className="top">
          <div className="left">
            {/* <div className="editbutton">Edit</div> */}
            <div style={{display: 'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
            <h2 style={{marginLeft:20, marginTop:20, marginBottom:20, color:'#666'}}>{advertData.title} Advert Information</h2>

            {
              adminRole === "adminAccess"

              ?

                <div style={{display:'flex', flexDirection:'row', gap:10, justifyContent:'center', alignItems:'center', marginRight:100 }}>
                <a onClick={(event)=> {event.preventDefault(); setOpenStatus(true);}}  style={{ border: '1px solid green', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:advertData.status === "active" ? "green" : "red", cursor:'pointer'}}>
                    <span style={{color:'white', fontWeight:'bold'}}>{advertData.status === "active" ? "Active" : "Inactive"}</span>
                </a>

                 <Link to={`/adverts/edit/${advertId}`} style={{ border: '1px solid blue', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:"blue", cursor:'pointer'}}>
                    <span style={{color:'white', fontWeight:'bold'}}>Edit</span>
                </Link>

      

            </div>

            :

            adminRole === "subadminAccess"

            ?

              <div style={{display:'flex', flexDirection:'row', gap:10, justifyContent:'center', alignItems:'center', marginRight:100 }}>
                <a onClick={(event)=> {event.preventDefault(); setOpenStatus(true);}}  style={{ border: '1px solid green', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:advertData.status === "active" ? "green" : "red", cursor:'pointer'}}>
                    <span style={{color:'white', fontWeight:'bold'}}>{advertData.status === "active" ? "Active" : "Inactive"}</span>
                </a>

                 <Link to={`/adverts/edit/${advertId}`} style={{ border: '1px solid blue', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:"blue", cursor:'pointer'}}>
                    <span style={{color:'white', fontWeight:'bold'}}>Edit</span>
                </Link>

      

            </div>

            :

            ""



            }

          
         

            </div>
            <div className='item'>
              {/* <div style={{width:'200px', height:'200px', alignItems:'center', justifyContent:'center'}}>

              <img
                src = {outlet }
                alt="avatar"
                style={{width:'100px', height:'100px'}}
                   
              /> 

              </div> */}
          
              
                <div className="details">
                  {/* <h3 className='itemTitle'>Outlet Information</h3> */}
                  {/* <div className='detailItem'>
                    <span className='itemKey'>Advert ID:</span>
                    <span className='itemValue'>{advertData.subscriberID}</span>
                  </div> */}
                  <div className='detailItem'>
                    <span className='itemKey'>Advert Title:</span>
                    <span className='itemValue'>{advertData.title}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Advert Description:</span>
                    <span className='itemValue'>{advertData.description}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Date Published:</span>
                    <span className='itemValue'>{advertData.datePublished}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Address:</span>
                    <span className='itemValue'>{advertData.brandaddress}</span>
                  </div>
                </div>


                <div className="details">
                  {/* <h3 className='itemTitle'></h3> */}
                  <div className='detailItem'>
                    <span className='itemKey'>Brand name:</span>
                    <span className='itemValue'>{advertData.brandname}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Brand Address:</span>
                    <span className='itemValue'>{advertData.brandaddress}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Brand Telephone:</span>
                    <span className='itemValue'>{advertData.brandtelephone}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Brand Socials:</span>
                    <span className='itemValue'>{advertData.brandsocials}</span>
                  </div>

                  {/* <div className='detailItem'>
                    <span className='itemKey'>Outlet Creation Date:</span>
                    <span className='itemValue'>{advertData.date}</span>
                  </div> */}
                 
                </div>



                <div className="details">
                  {/* <h3 className='itemTitle'></h3> */}
                  <div className='detailItem'>
                    <span className='itemKey'>Likes:</span>
                    <span className='itemValue'>{advertData.likeCount}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Views:</span>
                    <span className='itemValue'>{advertData.viewCount}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Messages:</span>
                    <span className='itemValue'>{advertData.messageCount}</span>
                  </div>
                  {/* <div className='detailItem'>
                    <span className='itemKey'>Outlet Open Hour:</span>
                    <span className='itemValue'>{advertData.open}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Outlet Creation Date:</span>
                    <span className='itemValue'>{advertData.date}</span>
                  </div> */}
                 
                </div>

              

            </div>
          </div>
          
        </div>
        
        
        {/* <div className="top">
          <div className="left">
            <h2 style={{marginLeft:20, marginTop:20, marginBottom:20, color:'#666'}}>Subscriber(Owner) Details</h2>
            <div className='item'>
            <img
                src = {advertData.userImage ? advertData.userImage : img}
                alt="avatar"
                style={{width:'100px', height:'100px', borderRadius:'50%', marginTop:20}}
                   
            /> 
              
                <div className="details">
                  <div className='detailItem'>
                    <span className='itemKey'>Customer ID:</span>
                    <span className='itemValue'>{advertData.userCustomerId}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Firstname:</span>
                    <span className='itemValue'>{advertData.userFirstname}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Lastname:</span>
                    <span className='itemValue'>{advertData.userLastname}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Gender:</span>
                    <span className='itemValue'>{advertData.userGender}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Age Range:</span>
                    <span className='itemValue'>
                      {
                      advertData.ageRange === "firstagerange"
                      ?
                      "18 to 29"
                      :
                      advertData.ageRange === "secondagerange"
                      ?
                      "30 to 39"
                      :
                      advertData.ageRange === "thirdagerange"
                      ?
                      "40 to 59"
                      :
                      "60 and Above"
                   
                      }
                    </span>
                  </div>
                </div>


                <div className="details">
                  <div className='detailItem'>
                    <span className='itemKey'>Telephone:</span>
                    <span className='itemValue'>{advertData.userTelephone}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Email:</span>
                    <span className='itemValue'>{advertData.userEmail}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Outlet Telephone:</span>
                    <span className='itemValue'>{advertData.telephone}</span>
                  </div>
                
                 
                </div>


            </div>
          </div>
        
        </div>
        <div className="top">
          <div className="left">
            <h2 style={{marginLeft:20, marginTop:20, marginBottom:20, color:'#666'}}>Outlet Photos</h2>
            <div style={{display:'flex', flexDirection:'row', gap:30, flexWrap:'wrap'}}>

     
          
             {
              photos.map(item =>(
                <div key={item}  style={{position:'relative'}}>
              

                  <div style={{display:'flex', position:'absolute', top:10, right:10, width:30, height:30, justifyContent:'center', borderRadius:'50%', backgroundColor:'#666'}}><h4 style={{alignSelf:'center', color:'#999'}}>X</h4></div>

                    <img
                    
                      key={item}
                      src = {item}
                      alt="avatar"
                      style={{width:'200px', height:'200px', borderRadius:10}}
                    
                    /> 
                  
                </div>
              ))
             } 
          
              

            </div>
          </div>
         
        </div> */}


        {/* <div className="top">
          <div className="left">
            <h2 style={{marginLeft:20, marginTop:20, marginBottom:20, color:'#666'}}>Outlet Reviews</h2>

            {
              review.map(item => (

                <div style={{display:'flex', flexDirection:'column', gap:10, padding:20}}>
                  <div style={{display:'flex', flexDirection:'row', alignItems:'center', gap:20}}>

                    <img
                      src = {commentorPhoto}
                      alt="avatar"
                      style={{width:'60px', height:'60px', borderRadius:'50%'}}
                        
                    /> 
                    <div style={{display:'flex', flexDirection:'column', gap:10}}>
                      <p style={{ color:'#666', fontweight:300, fontsize:14}}>{item.commentor}</p>
                      <p style={{fontweight:200, color:'#ccc', fontsize:12}}>{item.today}</p>
                    </div>

                  </div>
            
                  <p style={{color:'#999'}}>{item.review}</p>
                <div>

           </div>


            </div>

              ))
            }


            
          </div>
         
        </div> */}

        

        <div className="bottom">

             <img
                    
              src = {advertData.advertImage}
              alt="avatar"
              style={{width:'100%', height:'100%', borderRadius:10}}
            
            /> 
      
        </div>

        <ConfirmStatusBox
          openStatus={openStatus}
          closeDialog={() => setOpenStatus(false)}
          statusFunction={handleStatus }
        />



      </div>
    </div>
  )
}

export default Single